import growerBundlesSlices from './bundles';
import growersProtocolsSlices from './protocols';

const growersSlices = [growerBundlesSlices, growersProtocolsSlices];

export default growersSlices;
